var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "container relative-position",
        staticStyle: { "min-height": "95vh" }
      },
      [
        _vm.resource && _vm.loaded
          ? _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "page-tool-bar" },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "on-left",
                            attrs: {
                              flat: "",
                              small: "",
                              round: "",
                              color: _vm.azOpen ? "info" : ""
                            },
                            on: {
                              click: function($event) {
                                _vm.azOpen = !_vm.azOpen
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n              Show Alphabet Filters\n            "
                              )
                            ]),
                            _c("q-icon", { attrs: { name: "sort_by_alpha" } })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.azOpen
                      ? _c("az-bar", { attrs: { resource: _vm.resource } })
                      : _vm._e()
                  ],
                  1
                ),
                _c("select-layout-table", {
                  ref: "table",
                  attrs: { resource: _vm.resource }
                }),
                _c(
                  "q-btn",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    staticClass: "full-width",
                    attrs: { color: "primary", push: "", size: "lg" },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Save")]
                ),
                _c(
                  "q-btn",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    staticClass: "q-mt-lg",
                    attrs: { flat: "", color: "negative", full: "" },
                    on: { click: _vm.close }
                  },
                  [_vm._v("Cancel")]
                )
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("q-pagination", {
                staticClass: "text-center justify-center",
                attrs: {
                  value: _vm.pagination.page,
                  color: "secondary",
                  min: 1,
                  max: _vm.maxPage,
                  "max-pages": 15,
                  "boundary-numbers": "",
                  "boundary-links": ""
                },
                on: { change: _vm.changePage }
              })
            ],
            1
          )
        ]),
        _c("q-inner-loading", { attrs: { visible: !_vm.loaded } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }